import { useRef, useState } from 'react';
import { ExtendedMapTemplate } from '@zep/types';
import { TemplateFilter } from './TemplateFilter';
import { OfficialTemplateList, PurchasedTemplateList } from './TemplateList';
interface CreateSpaceContentProps {
  showPurchasedMaps: boolean;
  onSelectTemplate?: (template: ExtendedMapTemplate) => void;
  selectedTemplate?: ExtendedMapTemplate | null;
}
export const CreateSpaceContent = ({
  showPurchasedMaps,
  onSelectTemplate,
  selectedTemplate
}: CreateSpaceContentProps) => {
  const [selectedCategoryId, setSelectedCategoryId] = useState(-1);
  const scrollRef = useRef<HTMLDivElement>(null);
  const handleCategoryChange = (categoryId: number) => {
    setSelectedCategoryId(categoryId);
    scrollRef.current?.scrollTo(0, 0);
  };
  return <div className="flex h-full" data-sentry-component="CreateSpaceContent" data-sentry-source-file="CreateSpaceContent.tsx">
      <div className="w-[240px] pb-[30px] pl-[10px] pr-[30px] pt-[10px]">
        <TemplateFilter selectedCategoryId={selectedCategoryId} onCategoryChange={handleCategoryChange} isPurchasedView={showPurchasedMaps} data-sentry-element="TemplateFilter" data-sentry-source-file="CreateSpaceContent.tsx" />
      </div>
      <div ref={scrollRef} className="min-h-0 flex-1 overflow-y-auto">
        {showPurchasedMaps ? <PurchasedTemplateList categoryId={selectedCategoryId} onSelectTemplate={onSelectTemplate} selectedTemplateId={selectedTemplate?.hashId} /> : <OfficialTemplateList categoryId={selectedCategoryId} onSelectTemplate={onSelectTemplate} selectedTemplateId={selectedTemplate?.hashId} />}
      </div>
    </div>;
};